import React from "react";
import foto from "../../images/Calendario Cigno 20232024.jpg"
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import brema from "../../images/News/Doc - 27 gen 2026 - 11-47-1.png"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";


function Brema () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <p className="text-center" style={{ fontSize: "22px", fontFamily: "Hammersmith One" }}>{"28.01.2026"}</p>
            <TitoloSezioni title={"Tragedia di Brema"} />
            <div className="container-foto-news m-auto" style={{display: "flex", flexDirection: "column"}}>
                <img src={brema} style={{width: "100%"}}></img>
            </div>
            <Space />

        </div>
    )
}
export default Brema